import React, { memo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import { Trackable } from '@dpdgroupuk/react-event-tracker';

import palette from '../styles/palette';
import { View } from '../Base';

const useStyles = makeStyles(({ typography }) => ({
  paper: {
    minWidth: typography.pxToRem(540),
    maxWidth: typography.pxToRem(540),
    minHeight: typography.pxToRem(160),
    borderRadius: 6,
  },
  title: {
    backgroundColor: palette.lightGrey,
    color: palette.typography.black.high,
    fontWeight: '500',
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(
      60
    )} ${typography.pxToRem(12)} ${typography.pxToRem(20)}`,
    lineHeight: typography.pxToRem(24),
    fontSize: typography.pxToRem(18),
  },
  content: {
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(20)} !important`,
    fontSize: typography.pxToRem(14),
    display: 'flex',
    justifyContent: 'center',
  },
  actions: {
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(
      20
    )} ${typography.pxToRem(20)}`,
  },
  closeContainer: {
    position: 'absolute',
    right: typography.pxToRem(16),
    top: typography.pxToRem(12),
  },
  closeIcon: {
    fontSize: typography.pxToRem(18),
    color: palette.typography.black.solid,
  },
}));

const SimpleModal = ({
  title,
  children,
  actions,
  open,
  onClose,
  DialogProps,
  loadId,
  rootClassName,
}) => {
  const classes = useStyles();

  return (
    <Trackable loadId={loadId} modal>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ className: classes.paper }}
        className={rootClassName}
        {...DialogProps}
      >
        <DialogTitle
          className={classes.title}
          TypographyProps={{
            style: {
              lineHeight: '24px',
              fontSize: '18px',
            },
          }}
        >
          {title}
          <View className={classes.closeContainer}>
            <IconButton
              size="small"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </View>
        </DialogTitle>
        <DialogContent
          className={classes.content}
          sx={{ padding: '16px 20px' }}
        >
          {children}
        </DialogContent>
        {actions && (
          <DialogActions className={classes.actions}>{actions}</DialogActions>
        )}
      </Dialog>
    </Trackable>
  );
};

export default memo(SimpleModal);
